module.exports = __webpack_public_path__ + "static/media/card-silver.c3a24237.png";